<div class="edit-profile-container">
    <!-- <h2 mat-dialog-title>{{heading}}
      <button class="button-close" mat-icon-button aria-label="close" mat-dialog-close >
        <mat-icon aria-label="Close dialog">close</mat-icon>
      </button>
    </h2> -->
    <mat-dialog-content class="form-content">
      @if(!isUpdated){
        <div class="top-text">
          Press save to finalize the username change. Auth0 will be updated accordingly, and the user will need to sign in with the new username.
        </div>
        <form class="signup-form" [formGroup]="profileForm">
        <div class="form-row">
          <div class="form-group">
            <app-text-input
             label="Username"
             [fieldType]="'username'"
             [control]="profileForm.controls['userName']"
             [maxLength]="50"
          >
          </app-text-input>
          </div>
          <div class="form-group">
            <mat-dialog-actions class="form-actions">
                <app-button [label]="'Cancel'" [buttonType]="'primary'" class="btn-cancel" mat-dialog-close
                ></app-button>
                <app-button [label]="'Save'" [buttonType]="'primary'" [isFilled]="true" (click)="updateProfile()"class="btn-update"
                ></app-button>
              </mat-dialog-actions>
          </div>
        </div>
      </form>}
      @if(isUpdated){
        <div>You have successfully updated your profile</div>
        <div class="button-container">
          <app-button [label]="'Continue'" [buttonType]="'primary'" class="btn-cancel" (click)="closeDialog()"
          ></app-button>
        </div>
      }
    </mat-dialog-content>
    <div class="mainError" *ngIf="mainError">{{ mainError }}</div>
  </div>
